// // src/components/dashboard/LeaderboardTab.jsx
// import { useState, useEffect, useMemo, useRef } from 'react';
// import { Globe, Search } from 'lucide-react';
// import axios from 'axios';
// import './../NewUserDashboard.css';
// import PerformerDetailModal from './PerformerDetailModal';;

// const rowsPerPage = 5;

// export default function LeaderboardTab() {
//   const [data, setData] = useState([]);
//   const [exams, setExams] = useState([]);
//   const [departments, setDepartments] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [selectedDept, setSelectedDept] = useState('all');
//   const [selectedExam, setSelectedExam] = useState('all');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [selectedPerformer, setSelectedPerformer] = useState(null);

//   const previousFilters = useRef({ dept: 'all', exam: 'all' });

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const params = {
//           plant_id: 1,
//           page: currentPage,
//           page_size: rowsPerPage,
//         };
//         if (selectedDept !== 'all') params.dept = selectedDept;
//         if (selectedExam !== 'all') params.exam = selectedExam;

//         const [lbRes, examRes, deptRes] = await Promise.all([
//           axios.get('/dashboard/leaderboard/', { params }),
//           axios.get('/dashboard/exam-titles/'),
//           axios.get('/dashboard/all-departments/')
//         ]);

//         setData(lbRes.data.data || []);
//         setHasMore(lbRes.data.pagination?.has_more || false);
//         setExams(examRes.data.exams || []);
//         setDepartments(deptRes.data.departments || []);
//       } catch (err) {
//         console.error("API Error:", err);
//         setData([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, [currentPage, selectedDept, selectedExam]);

//   // Reset page on filter change
//   useEffect(() => {
//     if (
//       selectedDept !== previousFilters.current.dept ||
//       selectedExam !== previousFilters.current.exam
//     ) {
//       setCurrentPage(1);
//     }
//     previousFilters.current = { dept: selectedDept, exam: selectedExam };
//   }, [selectedDept, selectedExam]);

//   // CLIENT-SIDE SEARCH — filters Name, Dept, Exam, Score, Rank
//   const filteredData = useMemo(() => {
//     if (!searchQuery.trim()) return data;

//     const query = searchQuery.toLowerCase().trim();
//     return data.filter(item =>
//       item.name.toLowerCase().includes(query) ||
//       item.dept.toLowerCase().includes(query) ||
//       item.exam.toLowerCase().includes(query) ||
//       String(item.score).includes(query) ||
//       String(item.rank).includes(query)
//     );
//   }, [data, searchQuery]);

//   const handleRowClick = (performer) => {
//     setSelectedPerformer(performer);
//     setModalOpen(true);
//   };

//   if (loading && data.length === 0) {
//     return (
//       <div className="pd-grid-1">
//         <div className="pd-chart-card">
//           <div className="pd-empty-state">
//             <div className="pd-spinner"></div>
//             <p>Loading leaderboard...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   const displayData = searchQuery ? filteredData : data;
//   const hasData = displayData.length > 0;

//   return (
//     <>
//       <div className="pd-grid-1">
//         <div className="pd-chart-card">
//           <div className="pd-chart-header">
//             <h3 className="pd-chart-title">Global Leaderboard</h3>
//             <div className="pd-leaderboard-filters">
//               <select value={selectedExam} onChange={e => setSelectedExam(e.target.value)} className="pd-select-sm">
//                 <option value="all">All Assessments</option>
//                 {exams.map((exam, i) => <option key={i} value={exam}>{exam}</option>)}
//               </select>

//               <select value={selectedDept} onChange={e => setSelectedDept(e.target.value)} className="pd-select-sm">
//                 <option value="all">All Departments</option>
//                 {departments.map((dept, i) => <option key={i} value={dept}>{dept}</option>)}
//               </select>

//               <div className="pd-search">
//                 <Search className="pd-icon-sm" />
//                 <input
//                   type="text"
//                   placeholder="Search name, dept, assessment, score, rank..."
//                   value={searchQuery}
//                   onChange={e => setSearchQuery(e.target.value)}
//                   className="pd-search-input"
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="pd-table-wrapper">
//             <table className="pd-table">
//               <thead>
//                 <tr>
//                   <th>Rank</th>
//                   <th>Name</th>
//                   <th>Dept</th>
//                   <th>Assessment</th>
//                   <th>Score</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {hasData ? (
//                   displayData.map(p => (
//                     <tr
//                       key={`${p.name}-${p.exam}-${p.rank}`}
//                       className="pd-table-row pd-clickable"
//                       onClick={() => handleRowClick(p)}
//                     >
//                       <td>#{p.rank}</td>
//                       <td>{p.name}</td>
//                       <td>{p.dept}</td>
//                       <td>{p.exam}</td>
//                       <td><strong>{p.score}%</strong></td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="5" className="pd-empty-cell">
//                       <div className="pd-empty-message">
//                         <Globe size={64} className="pd-empty-icon" />
//                         <p className="pd-empty-title">No performers found</p>
//                         <p className="pd-empty-hint">Try adjusting your filters or search</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>

//           <div className="pd-pagination">
//             <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>
//               Previous
//             </button>
//             <span>Page {currentPage}</span>
//             <button disabled={!hasMore} onClick={() => setCurrentPage(p => p + 1)}>
//               Next
//             </button>
//           </div>
//         </div>
//       </div>

//       <PerformerDetailModal
//         open={modalOpen}
//         performer={selectedPerformer}
//         onClose={() => setModalOpen(false)}
//       />
//     </>
//   );
// }




import { useState, useEffect, useRef, useCallback } from 'react';
import { Globe, Search } from 'lucide-react';
import axios from 'axios';
import './../NewUserDashboard.css';

import { QueryBuilderComponent } from '@syncfusion/ej2-react-querybuilder';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

import AssignmentPagination from "../../HR/Assign_Course/list_of_assignments/AssignmentPagination";
import TableEmptyRow from '../../shared/TableEmptyRow';

const rowsPerPage = 10;

/* Debounce (same pattern as your exams screen) */
const debounce = (func, delay) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
};

export default function LeaderboardTab() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterRule, setFilterRule] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const qbRef = useRef(null);
  const currentRuleRef = useRef(null);

  /* ---------------- FETCH ---------------- */

  const fetchLeaderboard = useCallback(async (rule = null, page = 1) => {
    try {
      setLoading(true);

      const params = {
        plant_id: 1,
        page,
        page_size: rowsPerPage,
      };

      const search = searchQuery.trim().replace(/%/g, "");

      if (search) {
        params.search = search;
      }
      if (rule?.rules?.length) params.filters = JSON.stringify(rule);

      const res = await axios.get('/dashboard/leaderboard/', { params });

      setRows(res.data.data || []);
      setHasMore(res.data.pagination?.has_more || false);
      setTotalPages(res.data.pagination?.total_pages || 1);
    } catch (err) {
      console.error("Leaderboard API Error:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [searchQuery]);

  const debouncedFetch = useCallback(
    debounce((rule, page) => fetchLeaderboard(rule, page), 400),
    [fetchLeaderboard]
  );

  useEffect(() => {
    debouncedFetch(filterRule, currentPage);
  }, [currentPage, filterRule, searchQuery]);

  /* ---------------- QUERY BUILDER CONFIG ---------------- */

  const stringOperators = [
    { key: 'Contains', value: 'contains' },
    { key: 'Equal', value: 'equal' },
    { key: 'Not Equal', value: 'notequal' },
    { key: 'Starts With', value: 'startswith' },
    { key: 'Ends With', value: 'endswith' },
  ];

  const numberOperators = [
    { key: 'Equal', value: 'equal' },
    { key: 'Greater Than', value: 'greaterthan' },
    { key: 'Less Than', value: 'lessthan' },
  ];

  const qbColumns = [
    { field: 'name', label: 'Name', type: 'string', operators: stringOperators },
    { field: 'dept', label: 'Department', type: 'string', operators: stringOperators },
    { field: 'exam', label: 'Assessment', type: 'string', operators: stringOperators },
    { field: 'score', label: 'Score', type: 'number', operators: numberOperators },
    // { field: 'rank', label: 'Rank', type: 'number', operators: numberOperators },
  ];

  const defaultRule = { condition: 'and', rules: [] };

  /* ---------------- FILTER ACTIONS ---------------- */

  const applyFilters = () => {
    const rule = currentRuleRef.current || defaultRule;
    setFilterRule(rule);
    setCurrentPage(1);
    fetchLeaderboard(rule, 1);
  };

  const clearFilters = () => {
    setFilterRule(null);
    setSearchQuery('');
    setCurrentPage(1);

    if (qbRef.current) {
      qbRef.current.setRules(defaultRule);
      currentRuleRef.current = defaultRule;
    }

    fetchLeaderboard(null, 1);
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="pd-grid-1">
      <div className="pd-chart-card">

        <div className="pd-chart-header">
          <h3 className="pd-chart-title">Global Leaderboard</h3>

          <div className="pd-leaderboard-filters">

            <div className="pd-search">
              <Search className="pd-icon-sm" />
              <input
                type="text"
                placeholder="Search leaderboard..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="pd-search-input"
              />
            </div>

            <ButtonComponent
              cssClass="btn"
              onClick={() => {
                if (showFilters) {
                  if (qbRef.current) {
                    qbRef.current.setRules(defaultRule);
                    currentRuleRef.current = defaultRule;
                  }

                  setFilterRule(null);
                  setSearchQuery('');
                  setCurrentPage(1);

                  fetchLeaderboard(null, 1);
                }

                setShowFilters(!showFilters);
              }}
            >
              {showFilters ? 'Close Filters' : 'Enable Filters'}
            </ButtonComponent>
          </div>
        </div>

        {/* ---------------- QUERY BUILDER ---------------- */}

        {showFilters && (
          <div className="qb-container">
            <QueryBuilderComponent
              ref={qbRef}
              dataSource={[]}
              columns={qbColumns}
              rule={defaultRule}
              ruleChange={args => (currentRuleRef.current = args.rule)}
              showButtons={false}
              summaryView={false}
            />

            <div className="qb-actions">
              <ButtonComponent cssClass="btn-negative" onClick={clearFilters}>
                Clear Filters
              </ButtonComponent>

              <ButtonComponent cssClass="btn" onClick={applyFilters}>
                Apply Filters
              </ButtonComponent>
            </div>
          </div>
        )}

        {/* ---------------- TABLE ---------------- */}

        {loading ? (
          <div className="pd-empty-state">
            <div className="pd-spinner"></div>
            <p>Loading leaderboard...</p>
          </div>
        ) : (
          <div className="pd-table-wrapper">
            <table className="pd-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Department</th>
                  <th>Assessment</th>
                  <th>Score</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <TableEmptyRow colSpan={5} message="No leaderboard data found" />
                ) : rows.map((p, i) => (
                  <tr key={i}>
                    <td>{p.rank}</td>
                    <td>{p.name}</td>
                    <td>{p.dept}</td>
                    <td>{p.exam}</td>
                    <td><strong>{p.score}%</strong></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ---------------- PAGINATION ---------------- */}

        {/* <div className="pd-pagination">
          <button
            disabled={currentPage === 1 || loading}
            onClick={() =>
              setCurrentPage(prev =>
                Math.max(prev - 1, 1)
              )
            }
          >
            Previous
          </button>

          <span>{currentPage} of {totalPages}</span>
          <button
            disabled={!hasMore || currentPage >= totalPages || loading}
            onClick={() =>
              setCurrentPage(prev =>
                Math.min(prev + 1, totalPages)
              )
            }
          >
            Next
          </button>
        </div> */}

        <AssignmentPagination
          page={currentPage}
          totalPages={totalPages}
          handlePageChange={(page) => {
            if (page >= 1 && page <= totalPages && !loading) {
              setCurrentPage(page);
            }
          }}
        />
      </div>
    </div>
  );
}

